import { Helmet } from "react-helmet-async";
import { HeroSection } from "@/components/sections/HeroSection";
import { ProofBand } from "@/components/sections/ProofBand";
import { BentoSection } from "@/components/sections/BentoSection";
import { CoreSolutionsSection } from "@/components/sections/CoreSolutionsSection";
import { HowItWorksSection } from "@/components/sections/HowItWorksSection";
import { IndustriesSection } from "@/components/sections/IndustriesSection";
import { CaseStudyTabs } from "@/components/sections/CaseStudyTabs";
import { ResultsSection } from "@/components/sections/ResultsSection";
import { FAQSection } from "@/components/sections/FAQSection";
import { ContactSection } from "@/components/sections/ContactSection";

const siteUrl = "https://fullscalemarketing.com.au";
const siteName = "FullScale Marketing";
const siteTitle =
  "FullScale Marketing | Digital Marketing for Trade & Service Businesses";
const siteDescription =
  "An Australian digital marketing partner for trade and local-service businesses — websites, Google visibility, reviews and faster lead follow-up.";
const siteImage = "https://fullscalemarketing.com.au/og-image.jpg";

const Index = () => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: siteName,
    url: siteUrl,
    logo: `${siteUrl}/og-image.jpg`,
    image: siteImage,
    description:
      "An Australian digital marketing partner for trade and local-service businesses.",
    sameAs: [
      "https://www.instagram.com/fullscale_marketing/",
      "https://www.facebook.com/p/FullScale-Marketing-61562089223781/",
    ],
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "MarketingAgency",
    "@id": `${siteUrl}/#organization`,
    name: siteName,
    description: siteDescription,
    url: siteUrl,
    logo: `${siteUrl}/logo.png`,
    image: siteImage,
    email: "info@fullscalemarketing.com.au",
    address: {
      "@type": "PostalAddress",
      addressCountry: "AU",
      addressRegion: "Australia",
    },
    areaServed: [{ "@type": "Country", name: "Australia" }],
    priceRange: "$$",
  };

  return (
    <>
      <Helmet>
        <title>{siteTitle}</title>
        <meta name="description" content={siteDescription} />
        <meta name="robots" content="index, follow, max-image-preview:large" />
        <meta name="author" content={siteName} />
        <link rel="canonical" href={`${siteUrl}/`} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${siteUrl}/`} />
        <meta property="og:title" content={siteTitle} />
        <meta property="og:description" content={siteDescription} />
        <meta property="og:image" content={siteImage} />
        <meta property="og:locale" content="en_AU" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={siteTitle} />
        <meta name="twitter:description" content={siteDescription} />
        <meta name="twitter:image" content={siteImage} />
        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(localBusinessSchema)}
        </script>
      </Helmet>

      <HeroSection />
      <ProofBand />
      <BentoSection />
      <CoreSolutionsSection />
      <HowItWorksSection />
      <IndustriesSection />
      <CaseStudyTabs />
      <ResultsSection />
      <FAQSection />
      <ContactSection />
    </>
  );
};

export default Index;
